import React, { useEffect, useRef, useState } from "react";
import { Modal, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { useFormContext } from "react-hook-form";
import { ImageIcons } from "../../../common/components/assets/commonassets/CommonAssets";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { ModalStyle } from "../../../common/components/ModalStyle";
import CommonPrintModal from "../../../common/components/printModal/CommonPrintModal";
import CommonPDFViewer from "../../../common/components/printModal/CommonPDFViewer";
import CustomInput from "../../../common/components/CustomInput";
import { getDocument } from "../services/EMRServices/emrServices";
// import { getImage } from "../../services/EMRServices/oncologyServices";
import { DeleteIcon, ImageIcon } from "./EmrCommonAsset/Asset";

export default function Documents(props) {
  const {
    doctomentData,
    setDocumentData,
    dataDocument,
    setDataDocument,
    image,
    setImage,
    open,
    setOpen,
    newDoc,
    setNewDoc,
    selectedFile,
    setSelectedFile,
    base64Image,
    setBase64Image,
    documentTypeList,
    setDocumentTypeList,
  } = props;
  const [save, setSave] = useState(false);

  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [pdf, setpdf] = useState(null);
  const [openPrint, setOpenPrint] = useState(false);
  const [path, setPath] = useState(null);
  const [indexed, setIndexed] = useState();
  const [url, setUrl] = useState(null);
  const [selectedFileType, setSelectedFilType] = React.useState("");
  const [pdfFile, setPdfFile] = React.useState("");

  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({});

  React.useEffect(() => {
    if (open === false) {
      setSelectedFilType("");
      setPdfFile("");
      setNewDoc(false);
    }
  }, [open]);

  React.useEffect(() => {
    if (openPrint === false) {
      setSelectedFilType("");
      setPdfFile("");
      setNewDoc(false);
    }
  }, [openPrint]);

  React.useEffect(() => {}, [open]);

  function deleteRow(index) {
    const newComplaintsData = [...doctomentData];
    newComplaintsData.splice(index, 1);
    setDocumentData(newComplaintsData);
    setDataDocument(newComplaintsData);
  }

  const handleClosePrint = () => {
    if (openPrint === true) {
      setOpenPrint(false);
    }
  };

  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
        <button
          onClick={() => {
            setEditOpen(true);
            setEdit(true);
            setRow(row);
            setIndex(index);
            // setSave(false)
          }}
        >
          <EditIcon />
        </button>
      </Tooltip> */}

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  function arrayBufferToBase64(buffer) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  // let nillWatch = watch("nill");
  const handleOpenImage = (index) => {
    let documentType = doctomentData[index].documentView
      ?.split(".")?.[1]
      ?.toLowerCase();
    // getImage(doctomentData[index].documentView, documentType).then(
    //   (response) => {
    //     if (documentType !== "pdf") {
    //       let newImage =
    //         "data:image/jpeg;base64," + arrayBufferToBase64(response?.data);
    //       setImage(newImage);
    //       setOpen(true);
    //     } else {
    //       setOpen(true);
    //     }
    //   },
    // );
  };

  useEffect(() => {
    getDocument()
      .then((response) => {
        setDocumentTypeList(response.data.result);
      })
      .catch((response) => {
        console.log(response);
      });
  }, []);

  const fileInputRef = useRef(null);

  const handleFileChange = (event, index) => {
    setNewDoc(true);
    const file = event.target.files[0];
    const newFileName = file ? file.name : ""; // Get the new filename or empty string if no file is selected

    setSelectedFile(newFileName);
    console.log(
      "The slected fileName for the slected document is :",
      newFileName,
    );

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      let tempString = base64String.split(",").toString();
      if (tempString?.length > 0) {
        tempString = tempString.split("base64,")[1];
      }
      let tempData = [...doctomentData];
      tempData[index].filename = newFileName;
      tempData[index].documentView = newFileName;
      tempData[index].documentPathBase64 = base64String.split(",")[1];
      setDocumentData(tempData);
      setBase64Image(tempString);
    };

    reader.readAsDataURL(file);
  };

  function base64ToBlob(base64) {
    const parts = base64.split(",");
    const mime = parts[0].match(/:(.*?);/)[1];
    const byteString = atob(parts[1]);

    const byteNumbers = new Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteNumbers[i] = byteString.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

  function renderInput(row, index, header) {
    setValue(`document${index}`, row.Document);
    setValue(`documentDescription${index}`, row.DocumentDescription);

    return (
      <>
        {header === "DocumentFile" && (
          <div className="flex gap-2">
            <div>
              <label htmlFor={`fileInput${index}`} className="flex gap-2">
                <ImageIcon />
              </label>

              <input
                id={`fileInput${index}`}
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => {
                  handleFileChange(e, index);
                  // setImageIndex(index);
                }}
              />
            </div>
          </div>
        )}
        {header === "DocumentView" && (
          <>
            {row?.filename !== null ? (
              <div>
                <button
                  type="button"
                  key={index}
                  onClick={(e) => {
                    if (
                      row?.DocumentView?.includes(".pdf") &&
                      row?.isNew === false
                    ) {
                      console.log("the file selected is PDF :", row);
                      setSelectedFilType("pdf");
                      // getImage(row.DocumentView, "pdf").then((response) => {
                      //   const pdfBlob = new Blob([response.data], {
                      //     type: "application/pdf",
                      //   });
                      //   const pdfurl = URL.createObjectURL(pdfBlob);
                      //   setPdfFile(pdfurl);
                      // });
                    }

                    e.preventDefault();

                    if (row?.isNew === false) {
                      handleOpenImage(index);
                    } else if (row?.isNew === true) {
                      if (row?.DocumentView?.toLowerCase()?.includes("pdf")) {
                        console.log(
                          "The new image name in the documents array is :",
                          row?.DocumentView?.toLowerCase()?.includes("pdf"),
                        );

                        setSelectedFilType("pdf");
                        const byteString = atob(row.documentPathBase64);

                        const byteArray = new Uint8Array(byteString.length);

                        for (let i = 0; i < byteString.length; i++) {
                          byteArray[i] = byteString.charCodeAt(i);
                        }

                        const pdfBlob = new Blob([byteArray], {
                          type: "application/pdf",
                        });

                        const url = URL.createObjectURL(pdfBlob);

                        setPdfFile(url);
                        setOpen(true);
                      } else {
                        setPath(row.documentPathBase64);

                        let newImage =
                          "data:image/jpeg;base64," + row.documentPathBase64;
                        setImage(newImage);
                        setOpen(true);
                      }
                    }
                  }}
                >
                  <ImageIcon />
                </button>
              </div>
            ) : (
              <>{row.filename}</>
            )}
          </>
        )}
        {header === "Document" && (
          <div>
            <CustomInput
              name={`document${index}`}
              variant="outlined"
              // label="Document *"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              error={errors.document}
              control={control}
              inputRef={{
                ...register(`document${index}`, {
                  onChange: (e) => {
                    let tempData = [...doctomentData];
                    tempData[index].document = e.target.value;
                    setDocumentData(tempData);
                  },
                }),
              }}
            />
          </div>
        )}
        {/* {header === "DocumentDescription" && (
          <div>
            <CustomInput
              name={`documentDescription${index}`}
              variant="outlined"
              // label="Description *"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault()
                }
              }}
              error={errors.document}
              control={control}
              inputRef={{
                ...register(`documentDescription${index}`, {
                  onChange: (e) => {
                    let tempData = [...doctomentData];
                    tempData[index].documentDescription = e.target.value;
                    setDocumentData(tempData);
                  },
                }),
              }}
            />
          </div>
        )} */}
      </>
    );
  }

  let base = "data:image/jpeg;base64," + path;
  let documentType = watch("documentType");
  let documentDescription = watch("documentDescription");
  let document = watch("document");
  let filename = watch("filename");

  useEffect(() => {
    if (
      documentType !== null &&
      documentType !== undefined &&
      documentType !== ""
    ) {
      let obj = {
        documentType: documentType?.label,
        document: document,
        documentTypeId: documentType?.id,
        documentDescription: documentDescription,
        documentFile: null,
        isNew: true,
      };
      if (documentType?.label !== "" && documentType?.label !== undefined) {
        setDocumentData((prevState) => [...prevState, obj]);
        setValue("documentType", null);
        setValue("document", "");
        setSelectedFile(null);
      }
    }
  }, [documentType, selectedFile, base64Image]);

  return (
    <div>
      <div className="flex justify-between bg-[#EDE9FE] rounded-t-md ">
        <p className="text-sm font-semibold pl-2 py-1">Documents</p>
        <div className="w-72 flex gap-2">
          {/* <button
            type="button"
            onClick={() => {
              // setOpenAllergiesModal(true);
              // setSave(false);
            }}
          >
            <div className="mr-2 mt-1">
              <button
                type="button"
                onClick={() => {
                  setOpenDocumentModal(true);
                }}
              >
                <AddIcon />
              </button>
            </div>
          </button> */}
          <fieldset
            className="w-full"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              error={errors.allergyType}
              name="documentType"
              label="Document"
              placeholder="Document"
              dataArray={documentTypeList}
              handleInputChange={() => {
                setNewDoc(false);
              }}
              // isSearchable={false}
              // handleChange={handleChange}
              // onInputChange={handleChange}
              // autoFocus
            />
          </fieldset>
        </div>
      </div>
      <div
        className={`${"h-32"} w-full   overflow-auto border border-[#D9D9D9] rounded-b-md bg-white px-2`}
      >
        {doctomentData?.length > 0 ? (
          <CommonTransactionTable
            dataResult={doctomentData.map((row) => ({
              DocumentType: row.documentType,
              Document: row.document,
              DocumentFile: row.documentFile,
              DocumentView: row.documentView,
              isNew: row.isNew,
              fileName: row?.fileName,
              documentPathBase64: row?.documentPathBase64,
              DocumentDescription: row?.documentDescription,
            }))}
            renderActions={renderAction}
            renderInput={renderInput}
            editableColumns={["DocumentView", "Document", "DocumentFile"]}
            removeHeaders={[
              "documentPathBase64",
              "fileName",
              "DocumentDescription",
              "documentDescription",
              "isNew",
            ]}
            highlightRow={false}
          />
        ) : null}
      </div>
      {/* <DocumentsModal
        doctomentData={doctomentData}
        setDocumentData={setDocumentData}
        dataDocument={dataDocument}
        setDataDocument={setDataDocument}
        image={image}
        setImage={setImage}
        open={open}
        setOpen={setOpen}
        newDoc={newDoc}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
        documentTypeList={documentTypeList}
        setDocumentTypeList={setDocumentTypeList}
        setNewDoc={setNewDoc}
        openDocumentModal={openDocumentModal}
        setOpenDocumentModal={setOpenDocumentModal}
        setEditOpen={setEditOpen}
        edit={edit}
        setEdit={setEdit}
        row={row}
        index={index}
        setSave={setSave}
      /> */}

      <Modal
        open={open}
        // onClose={props.handleClose}
        // aria-labelledby="modal-modal-title"
        // aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="h-[90%] w-[90%] p-4 overflow-y-scroll ">
          <CancelPresentationIconButton
            onClick={() => {
              setOpen(false);
              setPath(null);
              setPdfFile("");
              setSelectedFilType("");
              // setNewDoc(false);
            }}
          />
          <div className="mt-10">
            {selectedFileType === "pdf" && pdfFile !== "" ? (
              <CommonPDFViewer pdfFile={pdfFile} />
            ) : newDoc !== true ? (
              <img src={image} name="img" alt="Image" />
            ) : (
              <img src={base} name="img" alt="Image" />
            )}
          </div>
        </Box>
      </Modal>

      <CommonPrintModal
        open={openPrint}
        handleClose={handleClosePrint}
        urlforPrint={pdf}
        setOpen={setOpenPrint}
      />
    </div>
  );
}
